import React from 'react';
import { PolicyRecommendation } from '../../graphQL/types/shared';
import { failIfValidOrNonExhaustive } from '../../Utils';
import {
  PolicyDimension,
} from '../Utils';

interface Props {
  policyRecommendation: PolicyRecommendation;
  policyDimension: PolicyDimension;
}

const PolicyCircle = (props: Props) => {
  const {policyDimension, policyRecommendation} = props;

  let imageURL: string;
  switch (policyDimension) {
    case PolicyDimension.LowHangingFruit:
      imageURL = require('./svgs-loaded-with-file-loader/low-hanging-fruit.svg');
      break;
    case PolicyDimension.BalancedPortfolio:
      switch (policyRecommendation) {
        case PolicyRecommendation.ParsimoniousIndustrial:
          imageURL = require('./svgs-loaded-with-file-loader/balanced-portfolio-parsimonious-policy.svg');
          break;
        case PolicyRecommendation.LightTouch:
          imageURL = require('./svgs-loaded-with-file-loader/balanced-portfolio-light-touch-policy.svg');
          break;
        case PolicyRecommendation.StrategicBets:
          imageURL = require('./svgs-loaded-with-file-loader/balanced-portfolio-strategic-bets-policy.svg');
          break;
        case PolicyRecommendation.TechFrontier:
          throw new Error('Countries that has technological frontier policy reommendation should not have this slide.');
        default:
          failIfValidOrNonExhaustive(policyRecommendation, 'Invalid policy recommendation ' + policyRecommendation);
          imageURL = '';
          break;
      }
      break;
    case PolicyDimension.LongJump:
      imageURL = require('./svgs-loaded-with-file-loader/long-jumps.svg');
      break;
    default:
      failIfValidOrNonExhaustive(policyDimension, 'Invalid policy dimension' + policyDimension);
      // These lines will never be executed:
      imageURL = '';
      break;
  }

  return (
    <img src={imageURL}/>
  );
};

export default PolicyCircle;
